module.exports = __webpack_public_path__ + "img/header-weddingRingsStylesNatural@2x.961595f.webp";